/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PermittedToSeeInfo/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaCheckbox from 'DesignSystem/TysiaCheckbox/index'
import TysiaCheckboxInput from 'DesignSystem/TysiaCheckbox/TysiaCheckboxInput/index'
import TysiaCheckboxText from 'DesignSystem/TysiaCheckbox/TysiaCheckboxText/index'



/** @type {import('Simple/types.js').View} */
export default function PermittedToSeeInfo({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Postal/NewAddress/Content/NewRelation/Add/Content/Relationship/PermittedToSeeInfo",
  onChange
  
}) {
let newRelationRelationshipPermittedToSeeInfoValueData = fromData.useDataValue({ viewPath,
context: 'new_relation',
path: 'relationship.permitted_to_see_info',
})
let newRelationRelationshipPermittedToSeeInfoChangeData = fromData.useDataChange({ viewPath,
context: 'new_relation',
path: 'relationship.permitted_to_see_info',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaCheckbox
  viewPath={`${viewPath}/TysiaCheckbox`}
 marginTop={dtSpaceS}
 data="new_relation.relationship.permitted_to_see_info"
 value={newRelationRelationshipPermittedToSeeInfoValueData}
 onChange={newRelationRelationshipPermittedToSeeInfoChangeData}
>
{childProps => (
<React.Fragment>
<TysiaCheckboxInput
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxInput`}
/>
<TysiaCheckboxText
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxText`}
 text="Permitted to see patient info"
/>
</React.Fragment>
)}
</TysiaCheckbox>
{children}
</React.Fragment>)
}